/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationMetadataCreateDTO } from '../models/OrganizationMetadataCreateDTO'
import type { OrganizationMetadataDTO } from '../models/OrganizationMetadataDTO'
import type { OrganizationMetadataPatchDTO } from '../models/OrganizationMetadataPatchDTO'
import type { PaginatedDTO_OrganizationMetadataDTO_ } from '../models/PaginatedDTO_OrganizationMetadataDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenOrganizationMetadataService {
    /**
     * Index
     * @returns PaginatedDTO_OrganizationMetadataDTO_ Successful Response
     * @throws ApiError
     */
    public static indexOrganizationMetadataGet({
        page = 1,
        limit = 10,
        sort
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_OrganizationMetadataDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/organization-metadata',
            query: {
                page: page,
                limit: limit,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create
     * @returns OrganizationMetadataDTO Successful Response
     * @throws ApiError
     */
    public static createOrganizationMetadataPost({
        requestBody
    }: {
        requestBody: OrganizationMetadataCreateDTO
    }): CancelablePromise<OrganizationMetadataDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/organization-metadata',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns OrganizationMetadataDTO Successful Response
     * @throws ApiError
     */
    public static getOrganizationMetadataOrganizationMetadataIdGet({
        organizationMetadataId
    }: {
        organizationMetadataId: string
    }): CancelablePromise<OrganizationMetadataDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/organization-metadata/{organization_metadata_id}',
            path: {
                organization_metadata_id: organizationMetadataId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Patch
     * @returns OrganizationMetadataDTO Successful Response
     * @throws ApiError
     */
    public static patchOrganizationMetadataOrganizationMetadataIdPatch({
        organizationMetadataId,
        requestBody
    }: {
        organizationMetadataId: string
        requestBody: OrganizationMetadataPatchDTO
    }): CancelablePromise<OrganizationMetadataDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/organization-metadata/{organization_metadata_id}',
            path: {
                organization_metadata_id: organizationMetadataId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * Delete organization metadata.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteOrganizationMetadataOrganizationMetadataIdDelete({
        organizationMetadataId
    }: {
        organizationMetadataId: string
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/organization-metadata/{organization_metadata_id}',
            path: {
                organization_metadata_id: organizationMetadataId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Trigger Backfill Friendly Ids
     * Trigger async backfill of friendly_id for all records missing one.
     *
     * Requires admin scope. The backfill runs as a Celery task on the aspen-queue.
     * Idempotent — safe to call multiple times.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static triggerBackfillFriendlyIdsOrganizationMetadataBackfillFriendlyIdsPost(): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/organization-metadata/backfill-friendly-ids'
        })
    }
}
